import styled from "styled-components";

export const Input = styled.input`
  width: 100%;
  height: 38px;
  border-radius: 3px;
  background-color: ${({ theme }) => theme.color.bgColor};
  border: solid 1px transparent;
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  color: #1e1e1e;

  &::placeholder {
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    text-align: left;
    color: #aaaaaa;
  }

  &:not(:read-only) {
    &:focus {
      border: solid 1px #00c7c7;
      background-color: #ffffff;
    }
  }

  &:read-only,
  &:disabled {
    cursor: not-allowed;
    color: #808080;
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }

  opacity: 1 !important;
`;
